import React from 'react';
import './TestimonialsSection.css';
import test from '../Images/test.jpg'
import test1 from '../Images/test1.jpg'

const testimonials = [
  {
    name: "Ananya Sharma",
    role: "Hyderabad, India",
    image: "https://spinellejewelry.com/cdn/shop/files/1689315186811.jpg?v=1718714049&width=375",
    feedback: "Spinelle's diamond ring collection is simply exquisite. The craftsmanship is top-notch, and the sparkle is unmatched. I feel like a queen every time I wear it!"
  },
  {
    name: "Rohan Mehta",
    role: "Mumbai, India",
    image: test1,
    feedback: "I was amazed by the attention to detail in their customized pendant. The entire process was smooth, and the final product exceeded my expectations."
  },
  {
    name: "Priya Kapoor",
    role: "Bangalore, India",
    image: test,
    feedback: "The rose gold earrings I bought from Spinelle are my new favorite! Their designs are luxurious yet wearable daily. Excellent service too."
  }
];

const TestimonialsSection = () => {
  return (
    <section className="testimonials-section">
      <h2 className="section-title">What Our Customers Say ✦</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card" key={index}>
            <div className="testimonial-image">
              <img src={testimonial.image} alt={testimonial.name} />
            </div>
            <p className="testimonial-feedback">"{testimonial.feedback}"</p>
            <h4 className="testimonial-name">{testimonial.name}</h4>
            <span className="testimonial-role">{testimonial.role}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
